import _slicedToArray from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useRef, useMemo, useCallback } from "react";
import styled, { css } from "styled-components";
import { getBreakpointWidth } from "../utils/mediaQuery";
import { SIZE_OPTIONS } from "./consts";
import { StyledText } from "../Text";
import Portal from "../Portal";
import RandomID from "../utils/randomID";
import { QUERIES } from "../utils/mediaQuery/consts";
import useTheme from "../hooks/useTheme";
import TooltipContent from "./components/TooltipContent";
import useStateWithTimeout from "../hooks/useStateWithTimeout";
var StyledTooltipChildren = styled.span.withConfig({
  displayName: "Tooltip__StyledTooltipChildren",
  componentId: "sc-1l15bi-0"
})(["display:inline-block;&:focus:active{outline:none;}", ";"], function (_ref) {
  var enabled = _ref.enabled,
      removeUnderlinedText = _ref.removeUnderlinedText;
  return enabled && !removeUnderlinedText && css(["", "{display:inline-block;text-decoration:underline;text-decoration:underline currentColor dotted;}"], StyledText);
});

var Tooltip = function Tooltip(_ref2) {
  var children = _ref2.children,
      _ref2$enabled = _ref2.enabled,
      enabled = _ref2$enabled === void 0 ? true : _ref2$enabled,
      _ref2$tabIndex = _ref2.tabIndex,
      tabIndex = _ref2$tabIndex === void 0 ? "0" : _ref2$tabIndex,
      dataTest = _ref2.dataTest,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? SIZE_OPTIONS.SMALL : _ref2$size,
      content = _ref2.content,
      preferredPosition = _ref2.preferredPosition,
      _ref2$stopPropagation = _ref2.stopPropagation,
      stopPropagation = _ref2$stopPropagation === void 0 ? false : _ref2$stopPropagation,
      removeUnderlinedText = _ref2.removeUnderlinedText;
  var theme = useTheme();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      shown = _useState2[0],
      setShown = _useState2[1];

  var _useStateWithTimeout = useStateWithTimeout(false, 200),
      _useStateWithTimeout2 = _slicedToArray(_useStateWithTimeout, 4),
      render = _useStateWithTimeout2[0],
      setRender = _useStateWithTimeout2[1],
      setRenderWithTimeout = _useStateWithTimeout2[2],
      clearRenderTimeout = _useStateWithTimeout2[3];

  var _useStateWithTimeout3 = useStateWithTimeout(false, 200),
      _useStateWithTimeout4 = _slicedToArray(_useStateWithTimeout3, 3),
      shownMobile = _useStateWithTimeout4[0],
      setShownMobile = _useStateWithTimeout4[1],
      setShownMobileWithTimeout = _useStateWithTimeout4[2];

  var tooltipId = useMemo(function () {
    return RandomID("tooltip");
  }, []);
  var container = useRef(null);
  var handleIn = useCallback(function () {
    if (window.innerWidth > +getBreakpointWidth(QUERIES.LARGEMOBILE, theme, true)) {
      setRender(true);
      setShown(true);
      clearRenderTimeout();
    }
  }, [clearRenderTimeout, setRender, theme]);
  var handleOut = useCallback(function () {
    if (window.innerWidth > +getBreakpointWidth(QUERIES.LARGEMOBILE, theme, true)) {
      setShown(false);
      setRenderWithTimeout(false);
    }
  }, [setRenderWithTimeout, theme]);
  var handleInMobile = useCallback(function (ev) {
    if (stopPropagation) {
      ev.stopPropagation();
    }

    if (window.innerWidth <= +getBreakpointWidth(QUERIES.LARGEMOBILE, theme, true)) {
      setRender(true);
      setShownMobileWithTimeout(true);
      clearRenderTimeout();
    }
  }, [clearRenderTimeout, setRender, setShownMobileWithTimeout, stopPropagation, theme]);
  var handleOutMobile = useCallback(function () {
    setShownMobile(false);
    setRenderWithTimeout(false);
  }, [setRenderWithTimeout, setShownMobile]);
  return React.createElement(React.Fragment, null, React.createElement(StyledTooltipChildren, {
    onMouseEnter: handleIn,
    onMouseLeave: handleOut,
    onClick: handleInMobile,
    onFocus: handleIn,
    onBlur: handleOut,
    ref: container,
    "aria-describedby": enabled ? tooltipId : undefined,
    tabIndex: enabled ? tabIndex : undefined,
    enabled: enabled,
    removeUnderlinedText: removeUnderlinedText
  }, children), enabled && render && React.createElement(Portal, {
    renderInto: "tooltips"
  }, React.createElement(TooltipContent, {
    dataTest: dataTest,
    shownMobile: shownMobile,
    shown: shown,
    size: size,
    tooltipId: tooltipId,
    onClose: handleOut,
    onCloseMobile: handleOutMobile,
    onEnter: handleIn,
    preferredPosition: preferredPosition,
    containerRef: container
  }, content)));
};

export default Tooltip;